module.exports = __webpack_public_path__ + "static/groceries.7dcb1e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surroundings/groceries.jpg
// module id = 415
// module chunks = 23221215298982